(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("SiteDetailsViewModel", SiteDetailsViewModelFactory);

  /** @ngInject */
  function SiteDetailsViewModelFactory(gridUtils, $translate, $timeout) {
    function SiteDetailsViewModel() {
      this.gridSettings = gridUtils.getDefaultGridSettings();

      this.washFacilityList = [];
      this.alarmList = [];
      this.lastReportTimestamp = "";
      this.selected = [];
      this.limitPerPage = this.gridSettings.limitPerPage;
      this.currentPage = this.gridSettings.page;
      this.pagerLabel = this.gridSettings.translations;

      // Grid data
      this.alarmsData = [];
      this.alarmsOrderBy = "timestamp";
      this.alarmsOrder = "desc";
      this.alarmsPage = 1;
      this.alarmsTotal = 0;
      this.alarmsPageSize = 10;
      this.alarmsPageOptions = [5, 10, 15];
      this.pagerTranslations = {
        page: $translate.instant("GRID_PAGER_PAGE"),
        rowsPerPage: $translate.instant("GRID_PAGER_ROWS_PER_PAGE"),
        of: $translate.instant("GRID_PAGER_PAGE_OF")
      };
    }

    SiteDetailsViewModel.prototype.destroy = function () {};

    SiteDetailsViewModel.prototype.alarmsPaginationChanged = function (
      page,
      limit
    ) {
      this.alarmsPage = page;
      this.alarmsPageSize = limit;
    };

    SiteDetailsViewModel.prototype.alarmsOrderingChanged = function (order) {
      var orderQuery = getOrderObject(order);
      this.alarmsOrderBy = orderQuery.orderBy;
      this.alarmsOrder = orderQuery.order;
    };

    SiteDetailsViewModel.prototype.refresh = function (data) {
      this.washFacilityList = this.setStateIcon(data, true);
      this.alarmList = this.setFacilityIcon(data);
    };

    SiteDetailsViewModel.prototype.refreshAlarmList = function (data) {
      if (data.content.length === 0) {
        this.alarmList = [];
        this.alarmList.push({
          timestamp: $translate.instant("NOTHING_TO_DISPLAY")
        });
      } else {
        this.alarmList = this.setStateIcon(data.content, false);
      }
      this.alarmsTotal = data.totalElements;
    };

    SiteDetailsViewModel.prototype.setStateIcon = function (data, switcher) {
      for (var i = 0; i < data.length; i++) {
        data[i].lastReportedTime = moment(
          data[i].lastReportTimestamp
        ).fromNow();
        switch (true) {
          case data[i].temperature > 23:
            data[i].currentFacilityTempIcon = "assets/images/weather_sunny.png";
            break;
          case 7 < data[i].temperature && data[i].temperature < 23:
            data[i].currentFacilityTempIcon = "assets/images/weather_cloud.png";
            break;
          case data[i].temperature < 7:
            data[i].currentFacilityTempIcon = "assets/images/weather_snow.png";
            break;
        }

        // Set alarm icons
        var caseItem = switcher
          ? data[i].facilityStatus
          : data[i].karcherFault.washFacilityStatus;
        switch (caseItem) {
          case "INFO":
            data[i].icon = "assets/icons/ic_low_alarm.svg";
            break;
          case "WARNING":
            data[i].icon = "assets/icons/ic_medium_alarm.svg";
            break;
          case "ALARM":
            data[i].icon = "assets/icons/ic_high_alarm.svg";
            break;
          default:
            data[i].icon = "assets/icons/ic_low_alarm.svg";
            break;
        }
      }
      return data;
    };

    SiteDetailsViewModel.prototype.setFacilityIcon = function (data) {
      data.forEach(function (item) {
        switch (item.facilityType) {
          case "JETWASH":
            item.washFacilityIcon = "assets/images/self_service_new.svg";
            break;
          case "ROLLOVER":
            item.washFacilityIcon = "assets/images/rollover_new.svg";
            break;
        }
      });
      return data;
    };

    SiteDetailsViewModel.prototype.updateFeedValues = function (newFeedData) {
      var that = this;
      $timeout(function () {
        that.washFacilityList.forEach(function (washFacilityItem) {
          if (newFeedData.path.indexOf(washFacilityItem.deviceKey) > -1) {
            if (newFeedData.data.reference === "OP_TEMPERATURA_MJERENA") {
              washFacilityItem.temperature = newFeedData.data.currentValue;
              washFacilityItem.lastReportedTime = moment(
                newFeedData.data.lastUpdate
              ).fromNow();
              switch (true) {
                case washFacilityItem.temperature > 23:
                  washFacilityItem.currentFacilityTempIcon = "assets/images/weather_sunny.png";
                  break;
                case 7 < washFacilityItem.temperature && washFacilityItem.temperature < 23:
                  washFacilityItem.currentFacilityTempIcon = "assets/images/weather_cloud.png";
                  break;
                case washFacilityItem.temperature < 7:
                  washFacilityItem.currentFacilityTempIcon = "assets/images/weather_snow.png";
                  break;
              }
            }
            if (newFeedData.data.reference === "RTC") {
              washFacilityItem.lastReportedTime = moment(
                newFeedData.data.lastUpdate
              ).fromNow();
            }
            if (newFeedData.data.reference === "STATE") {
              washFacilityItem.lastReportedTime = moment(
                newFeedData.data.lastUpdate
              ).fromNow();
              washFacilityItem.state = newFeedData.data.currentValue;
            }
          }
        });
      }, 50);
    };


    function getOrderObject(order) {
      var result = {
        order: "asc",
        orderBy: order
      };

      if (order.indexOf("-") > -1) {
        result.order = "desc";
        result.orderBy = order.substring(1);
      }
      return result;
    }

    return SiteDetailsViewModel;
  }
})();
